<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {},
		methods: {
			inputblur(e){
			this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			headercellstyle({ 
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 2);
							}
						});
					}
					if (columnIndex ===1) {
							return {
								display: "none"
							};
					}
					if (columnIndex === 2) {
							this.$nextTick(() => {
								if (document.getElementsByClassName(column.id).length !== 0) {
									document
										.getElementsByClassName(column.id)[0]
										.setAttribute('rowSpan', 2);
								}
							});
					}
				}
				if (rowIndex === 1) {
					if (columnIndex ===0) {
							return {
								display: "none"
							};
					}
				}
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
